import { Team__Cerveceras } from "../teams/Cerveceras";
import { Team__UTPaquime } from "../teams/UTPaquime";
import { Team__Potras } from "../teams/Potras";
import { Team__Abejas } from "../teams/Abejas";
import { Team__Omega } from "../teams/Omega";

const Cerveceras = {
  team: Team__Cerveceras,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceras_2 = {
  team: Team__Cerveceras,
  playingPlayers: [],

  goals: 30,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 15,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime_2 = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 16,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 29,
  penaltyGoals: 0,
  isWinner: false,
};

const Abejas = {
  team: Team__Abejas,
  playingPlayers: [],

  goals: 54,
  penaltyGoals: 0,
  isWinner: false,
};

const Abejas_2 = {
  team: Team__Abejas,
  playingPlayers: [],

  goals: 52,
  penaltyGoals: 0,
  isWinner: false,
};

const Omega = {
  team: Team__Omega,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada3 = {
  jornadaPosition: 3,
  matches: [
    {
      team1: Cerveceras,
      team2: UTPaquime_2,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Potras,
      team2: Abejas,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Omega,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Cerveceras_2,
      team2: Abejas_2,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
